import styles from './header.module.css'
import { Helmet } from 'react-helmet'
import AakashLogo from '../../assets/AakashSignupLogo.png'
import profileicon from '../../assets/profile_icon_anthe.png'
import Callingicon from '../../assets/Calling.png'
import { useHistory } from 'react-router-dom'
import { useState } from 'react'
import {
    Container,
    Row,
    Col,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Dropdown,
} from 'reactstrap'
import { connect } from 'react-redux'
import EditProfile from 'components/EditProfileDetails/EditProfile'
import { USER_LOGOUT } from 'constants/actionTypes'
import { CUSTOMER_SUPPORT, SUPPORT_PHONE_NUMBER } from 'components/Result/constants'
import { getExamType } from 'utils/common'
import { TRUE } from 'sass'
import { dashboard_web } from 'utils/customWebengage'

const mapStateToProps = (state) => ({
    profileInfo: state?.profileData,
    token: state?.token,
})

const mapDispatchToProps = (dispatch) => ({
    resetUser: () => dispatch({ type: USER_LOGOUT }),
})

const Header = (props) => {
    const { profileData } = props
    const examType = getExamType()
    const history = useHistory()
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const toggle = () => setDropdownOpen((prevState) => !prevState)
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)

    const supportPhoneNumber =
        profileData?.branch_code === 'IC006' ? '8800312674' : SUPPORT_PHONE_NUMBER

    const handleClick = () => {
        props.resetUser()
        localStorage.clear()
        window.webengage.track(examType + '12_logout', {
            'mobile number': profileData.mobile_number,
            'roll number': profileData.roll_number,
            psid: profileData.student_psid ? profileData.student_psid : 'NA',
            'exam type': profileData.exam_type,
            class_studying: profileData.class.toString(),
            stream: profileData.stream,
            branchcode: profileData.exam_center_id,
            email: profileData.email,
            stream: profileData.classtream,
            board: profileData.exam_board,
            state: profileData.exam_state,
            payment_status: 'success',
            exam_date: profileData.exam_date_id,
            city: profileData.student_city,
            name: profileData.student_firstname,
            'utm parameters': localStorage.getItem('utmParams')
                ? localStorage.getItem('utmParams')
                : '',
        })
        window.webengage.user.logout(profileData.mobile_number)
        return history.push('/exam/login')
    }

    const handleEitProfile = () => {
        setIsEditModalOpen(!isEditModalOpen)
        window.webengage.track('iACST_db_edit_profile', {
            'mobile number': profileData.mobile_number,
            'roll number': profileData.roll_number,
            psid: profileData.student_psid ? profileData.student_psid : 'NA',
            'exam type': profileData.exam_type,
            class_studying: profileData.class.toString(),
            stream: profileData.stream,
            branchcode: profileData.exam_center_id,
        })
    }
    const handelprofclick = () => {
        dashboard_web('2_Profile_Click', profileData, examType)
    }
    const customer_support_number = CUSTOMER_SUPPORT

    return (
        <>
            {props.profileInfo.exam_type === 'MOCK-NEET' && (
                <Helmet>
                    <title>Aakash NEET Mock Test</title>
                </Helmet>
            )}

            {props.profileInfo.exam_type === 'MOCK-JEE' && (
                <Helmet>
                    <title>Invictus Open Test</title>
                </Helmet>
            )}
            <div className={styles.header}>
                <Container className="p-3 mw-100">
                    <Row>
                        <Col>
                            <img
                                className={styles.image}
                                src={AakashLogo}
                                alt="Aakash logo"
                            />
                        </Col>
                        <Col
                            xs
                            lg="3"
                            className="d-flex align-items-center justify-content-end"
                        >
                            {props.showmobile != 'false' ? (
                                <div
                                    className={styles.callingTollfree}
                                    onClick={() => {
                                        if (
                                            examType == 'IAT' ||
                                            examType == 'MOCK-JEE'
                                        ) {
                                            window.webengage.track(
                                                examType + '_call_us_clicked',
                                                {
                                                    page_url: window.location.href,
                                                    'utm parameters':
                                                        localStorage.getItem(
                                                            'utmParams',
                                                        )
                                                            ? localStorage.getItem(
                                                                  'utmParams',
                                                              )
                                                            : '',
                                                },
                                            )
                                        } else {
                                            window.webengage.track(
                                                'iACST_db_call_now',
                                                {
                                                    'support number': '1800-102-272',
                                                    'exam type':
                                                        profileData.exam_type,
                                                    center: profileData.center_name,
                                                    class: profileData.class,
                                                    stream: profileData.stream,
                                                },
                                            )
                                        }
                                    }}
                                >
                                    <a
                                        href={`tel:${supportPhoneNumber}`}
                                        className="font-size-md text-white text-decoration-none d-flex"
                                    >
                                        <img
                                            src={Callingicon}
                                            className={styles.callingIcon}
                                            alt="calling-icon"
                                        />
                                        <span className="d-none d-md-block">
                                            {' '}
                                            {supportPhoneNumber}
                                        </span>
                                    </a>
                                </div>
                            ) : (
                                ''
                            )}
                            <div className="ms-4">
                                {profileData ? (
                                    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                        <DropdownToggle className="bg-blue border-0">
                                            <img
                                                src={profileicon}
                                                alt="user-profile-icon"
                                                onClick={handelprofclick}
                                            />
                                        </DropdownToggle>
                                        <DropdownMenu
                                            className={styles.logout_dropdown}
                                        >
                                            {!profileData.remove_edit_exam_edit_profile && (
                                                <DropdownItem>
                                                    <div
                                                        className={styles.logout}
                                                        onClick={handleEitProfile}
                                                    >
                                                        View Profile
                                                    </div>
                                                </DropdownItem>
                                            )}
                                            <DropdownItem>
                                                <div
                                                    className={styles.logout}
                                                    onClick={handleClick}
                                                >
                                                    Logout
                                                </div>
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                ) : null}
                            </div>
                        </Col>
                    </Row>
                    {isEditModalOpen && (
                        <EditProfile
                            fetchProfileData={props.fetchProfileData}
                            profileData={profileData}
                            token={props.token}
                            isModalOpen={isEditModalOpen}
                            toggle={handleEitProfile}
                        />
                    )}
                </Container>
            </div>
        </>
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(Header)
